import { render, staticRenderFns } from "./CheckApprovalTableBase.vue?vue&type=template&id=467d19ac"
import script from "./CheckApprovalTableBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckApprovalTableBase.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports